'use client';

import _defineProperty from "/codebuild/output/src2066/src/s3/01/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/codebuild/output/src2066/src/s3/01/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["component", "style", "__vars", "className", "variant", "mod", "size", "hiddenFrom", "visibleFrom", "lightHidden", "darkHidden", "renderRoot", "__size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import cx from 'clsx';
import { createPolymorphicComponent } from '../factory/create-polymorphic-component.mjs';
import { InlineStyles } from '../InlineStyles/InlineStyles.mjs';
import { isNumberLike } from '../utils/is-number-like/is-number-like.mjs';
import '@mantine/hooks';
import { useMantineSxTransform } from '../MantineProvider/Mantine.context.mjs';
import '../MantineProvider/default-theme.mjs';
import '../MantineProvider/MantineProvider.mjs';
import { useMantineTheme } from '../MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs';
import '../MantineProvider/MantineCssVariables/MantineCssVariables.mjs';
import { getBoxMod } from './get-box-mod/get-box-mod.mjs';
import { getBoxStyle } from './get-box-style/get-box-style.mjs';
import { extractStyleProps } from './style-props/extract-style-props/extract-style-props.mjs';
import { STYlE_PROPS_DATA } from './style-props/style-props-data.mjs';
import { parseStyleProps } from './style-props/parse-style-props/parse-style-props.mjs';
import { useRandomClassName } from './use-random-classname/use-random-classname.mjs';
var _Box = forwardRef(function (_ref, ref) {
  var _useSxTransform;
  var component = _ref.component,
    style = _ref.style,
    __vars = _ref.__vars,
    className = _ref.className,
    variant = _ref.variant,
    mod = _ref.mod,
    size = _ref.size,
    hiddenFrom = _ref.hiddenFrom,
    visibleFrom = _ref.visibleFrom,
    lightHidden = _ref.lightHidden,
    darkHidden = _ref.darkHidden,
    renderRoot = _ref.renderRoot,
    __size = _ref.__size,
    others = _objectWithoutProperties(_ref, _excluded);
  var theme = useMantineTheme();
  var Element = component || "div";
  var _extractStyleProps = extractStyleProps(others),
    styleProps = _extractStyleProps.styleProps,
    rest = _extractStyleProps.rest;
  var useSxTransform = useMantineSxTransform();
  var transformedSx = useSxTransform === null || useSxTransform === void 0 || (_useSxTransform = useSxTransform()) === null || _useSxTransform === void 0 ? void 0 : _useSxTransform(styleProps.sx);
  var responsiveClassName = useRandomClassName();
  var parsedStyleProps = parseStyleProps({
    styleProps: styleProps,
    theme: theme,
    data: STYlE_PROPS_DATA
  });
  var props = _objectSpread(_objectSpread({
    ref: ref,
    style: getBoxStyle({
      theme: theme,
      style: style,
      vars: __vars,
      styleProps: parsedStyleProps.inlineStyles
    }),
    className: cx(className, transformedSx, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, responsiveClassName, parsedStyleProps.hasResponsiveStyles), "mantine-light-hidden", lightHidden), "mantine-dark-hidden", darkHidden), "mantine-hidden-from-".concat(hiddenFrom), hiddenFrom), "mantine-visible-from-".concat(visibleFrom), visibleFrom)),
    "data-variant": variant,
    "data-size": isNumberLike(size) ? void 0 : size || void 0,
    size: __size
  }, getBoxMod(mod)), rest);
  return /* @__PURE__ */jsxs(Fragment, {
    children: [parsedStyleProps.hasResponsiveStyles && /* @__PURE__ */jsx(InlineStyles, {
      selector: ".".concat(responsiveClassName),
      styles: parsedStyleProps.styles,
      media: parsedStyleProps.media
    }), typeof renderRoot === "function" ? renderRoot(props) : /* @__PURE__ */jsx(Element, _objectSpread({}, props))]
  });
});
_Box.displayName = "@mantine/core/Box";
var Box = createPolymorphicComponent(_Box);
export { Box };